/**
 *
 *
 *
 *
 *
 *
 */
export function defineNamespace(implementation) {
    return { ...implementation, [Symbol.onexus.namespace]: true };
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineFunction(handler) {
    return handler;
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineEvent(...listeners) {
    return { [Symbol.onexus.event]: { listeners } };
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineStore(detail, start) {
    return { [Symbol.onexus.event]: { detail, start } };
}
